import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from '@/core/ui/Checkbox';
import { Divider, FormControlLabel, Paper } from '@mui/material';
import { t } from '@/core/localization';
import { SelectAllBox } from './SelectAllPaper.styled';
/**
 * CheckboxAutocomplete paper component.
 *
 * !IMPORTANT This component **must not be inline** since inline case causes the bug with scroll to top on change.
 * BUG: https://github.com/mui/material-ui/issues/31073
 * @param paperProps
 * @returns
 */
const SelectAllPaper = ({ paperProps, checkboxColor, selectAllCheckboxChecked, selectAllCheckboxIndeterminate, nothingFound, onSelectAllCheckboxClick, }) => {
    const { children, ...restPaperProps } = paperProps;
    return (_jsxs(Paper, { ...restPaperProps, 
        // Prevents popup close on paper click.
        onMouseDown: (event) => event.preventDefault(), children: [!nothingFound && (_jsxs(_Fragment, { children: [_jsx(SelectAllBox, { children: _jsx(FormControlLabel
                        // onClick handler used instead of Checkbox onChange since there happens bug when click not on checkbox
                        // icon itself but on label.
                        , { 
                            // onClick handler used instead of Checkbox onChange since there happens bug when click not on checkbox
                            // icon itself but on label.
                            onClick: onSelectAllCheckboxClick, label: t('select.all.label'), control: _jsx(Checkbox, { color: checkboxColor ?? 'primary', checked: selectAllCheckboxChecked, indeterminate: selectAllCheckboxIndeterminate }) }) }), _jsx(Divider, {})] })), children] }));
};
export { SelectAllPaper };
